<template>
  <div class="m-auto w-full" style="margin-top: 10%">
    <div
      class="text-md my-12 text-center font-bold uppercase tracking-wider text-white"
    >
      Select Game Type
    </div>

    <div class="flex flex-col justify-center md:flex-row">
      <div
        class="mx-auto flex w-full max-w-sm flex-shrink-0 flex-col items-center justify-center md:mx-8"
      >
        <div class="flex h-full flex-col justify-center gap-4">
          <div class="text-md text-center text-white">
            Play a game on the same computer
          </div>
          <button
            class="btn mb-4 items-start self-center"
            @click="openModal('local')"
          >
            Start local game
          </button>
        </div>
      </div>

      <div class="flex justify-center">
        <div class="my-16 h-px w-48 bg-white md:my-0 md:h-full md:w-px"></div>
      </div>

      <div
        class="mx-auto flex w-full max-w-sm flex-shrink-0 flex-col items-center justify-center md:mx-8"
      >
        <div class="mx-auto flex flex-col items-center justify-center gap-4">
          <div class="text-md text-center leading-6 text-white">
            Play a game over the internet
          </div>
          <div class="">
            <button
              class="btn items-start self-center"
              @click="openModal('online')"
            >
              Host game
            </button>
          </div>
          <div class="uppercase text-white">or</div>
          <div class="flex">
            <input
              class="input-btn uppercase"
              type="text"
              placeholder="Game code"
              v-model="joinGameCode"
            /><button
              class="btn"
              style="border-radius: 0 0.25em 0.25em 0"
              @click="joinOnlineGame"
            >
              Join game
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="relative z-0 mb-8 mt-24 text-center text-xs text-white opacity-80"
    >
      Photo by
      <a
        class="underline"
        href="https://unsplash.com/@birminghammuseumstrust?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText"
        >Birmingham Museums Trust</a
      >
      on
      <a
        class="underline"
        href="https://unsplash.com/s/photos/abstract-art-painting?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText"
        >Unsplash</a
      >
    </div>
  </div>
</template>

<script>
import { socket } from '../main'

export default {
  data() {
    return {
      gridSize: '3',
      players: 2,
      winCondition: 'First to 3',

      // local game
      isLocalGameCreated: false,

      // network game
      joinGameCode: '',
      isMultiplayerGameCreated: false,
      multiplayerGame: {},

      // other
      isLinkCopied: false,
      isCodeCopied: false,
      copiedTimeout: null,
    }
  },

  computed: {
    userId() {
      return this.getUserId()
    },
  },

  created() {
    socket.on('createdGame', (game) => {
      this.isMultiplayerGameCreated = true
      this.joinGameCode = game.gameId
      this.multiplayerGame = game
    })

    socket.on('joinedGame', (game) => {
      console.log('joinedGame', JSON.parse(game))
      const gameData = JSON.parse(game)

      this.$router.push(`/online/${gameData.gameId}`)

      this.isMultiplayerGameCreated = true
      this.multiplayerGame = JSON.parse(game)
    })

    socket.on('leftGame', (game) => {
      this.multiplayerGame = JSON.parse(game)
    })

    socket.on('startedGame', (game) => {
      this.$store.commit('SET_IS_GAME_ACTIVE', true)
    })
  },

  mounted() {
    if (this.$route.query.code) {
      this.joinGameCode = this.$route.query.code

      this.joinOnlineGame()
    }
  },

  methods: {
    socketConnection() {
      if (socket.disconnected) {
        socket.on('connect', () => {
          const engine = socket.io.engine

          engine.once('upgrade', () => {
            console.log('upgrade complete')
          })
        })
      }
    },

    socketCreateGame() {
      const userId = this.getUserId()
      const multiplayerGame = {
        settings: {
          gridSize: this.gridSize,
          players: this.players,
          winCondition: this.winCondition,
        },
        boardState: [],
        hostId: userId,
        players: [
          {
            userId: userId,
            username: this.getUsername(),
            playerNumber: 1,
            score: 0,
          },
        ],
        isActive: false,
        activePlayer: 1,
        winner: [],
      }

      socket.emit('createGame', multiplayerGame)
      this.multiplayerGame = multiplayerGame
    },

    getUserId() {
      return window.localStorage.getItem('id')
    },

    getUsername() {
      return window.localStorage.getItem('username')
    },

    createGame() {
      this.$store.commit('SET_IS_GAME_ACTIVE', true)
      this.isLocalGameCreated = true
    },

    createOnlineGame() {
      this.socketConnection()
      this.socketCreateGame()
    },

    joinOnlineGame() {
      // store a little cookie to track users
      socket.emit('joinGame', {
        gameId: this.joinGameCode.toUpperCase(),
        player: {
          userId: this.userId,
          username: this.getUsername(),
        },
      })
    },

    leaveOnlineGame(userId) {
      // user left the game or was booted
      socket.emit('leaveGame', {
        gameId: this.joinGameCode.toUpperCase(),
        player: {
          userId: userId,
        },
      })
    },

    startOnlineGame() {
      socket.emit('startGame', {
        gameId: this.multiplayerGame.gameId,
        player: {
          userId: this.userId,
          username: this.getUsername(),
        },
      })
    },

    newGame() {
      if (this.isLocalGameCreated) {
        this.gridSize = '3'
        this.players = 2
        this.winCondition = 'First to 3'
        this.isLocalGameCreated = false

        this.$store.commit('SET_IS_GAME_ACTIVE', false)
      }

      if (this.isMultiplayerGameCreated) {
        this.multiplayerGame = {}
        this.isMultiplayerGameCreated = false
        this.joinGameCode = ''
      }
    },

    restart() {
      if (this.isLocalGameCreated) {
        this.$refs.vboard.reset()
      }
    },

    copyText(string, type) {
      navigator.clipboard.writeText(string)

      if (this.copiedTimeout) {
        clearTimeout(this.copiedTimeout)
      }

      if (type === 'code') {
        this.isCodeCopied = true
      }

      if (type === 'link') {
        this.isLinkCopied = true
      }

      this.copiedTimeout = setTimeout(() => {
        this.isCodeCopied = false
        this.isLinkCopied = false
        this.copiedTimeout = null
      }, 2000)
    },

    openModal(type, code = '') {
      this.$store.commit('SET_ACTIVE_MODAL', type)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/Menu2.vue